module.exports = __webpack_public_path__ + "static/devices-557ac426151a0d27e622425aa3571e7d.png";